import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Arrow Left icon for back navigation
 */
export const ArrowLeftIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <line x1="19" y1="12" x2="5" y2="12"></line>
      <polyline points="12 19 5 12 12 5"></polyline>
    </Icon>
  );
};

export default ArrowLeftIcon;
